import { observable, action, makeObservable, runInAction } from 'mobx';
import { createContext } from 'react';

import { ObjectType } from '@vromo/models/helpers/models';



/** Keep track of local ( page ) UI state e,g, selected drivers and jobs, sorting, filtering */
export class PageStore {

    /** An object representing the settings for the current page / spa. useful on edit windows, for instance: { job: 4123 } */
    settings: ObjectType = {}
    /** BE queries are being performed, UI is expecting data updates */
    pageLoading = false
    /** Inital fetch was performed */
    fetched = false

    /** reset certain values when a root page is loaded: dispatch page, sites page etc.
     */
    initPage = () => {
        this.pageLoading = false
        this.settings = {}
    };

    setLoading = (state: boolean): void => {
        this.pageLoading = state
    }

    setFetched = (state: boolean): void => {
        this.fetched = state
    }

    // todo: add setters and getters for activeReocord and loading
    constructor() {
        makeObservable(this, {
            settings: observable,
            pageLoading: observable,
            fetched: observable,
            initPage: action,
            setLoading: action,
            setFetched: action
        });
    }
}

/** local context for current page  */
export const PageContext = createContext<PageStore>({} as PageStore)
export const dispatchPageStore = new PageStore()
